<template>
  <div :class='$style.login'>
    <h1 :class='$style.title'>シングルサインオン</h1>
    <p :class='$style.note'>所属ゆにおんの"ゆにおんキー"を入力してください</p>

    <base-input 
      name="contact" 
      look="border2" 
      v-model="union_key" 
      maxlength="7" 
      :error="errorMessage"
      @blur="validateUnionKey"
    >
      <template v-slot:prepend>
        <span :class="$style.input_prepend_contact">ゆにおんキー</span>
      </template>
    </base-input>
    <div :class="$style.next_button_wrap">
      <base-button display="inline-flex" width="100%" height="50px" @click="submit" :disabled="processing">
        次へ
      </base-button>
    </div>
  </div>
</template>

<script>
import BaseButton from '@/components/base/BaseButton/BaseButton'
import BaseInput from '@/components/base/BaseInput/BaseInput'

export default {
  name: 'LoginSaml',
  components: { BaseButton, BaseInput },
  data() {
    return {
      union_key: '',
      processing: false,
      errorMessage: ''
    }
  },
  methods: {
    validateUnionKey() {
      // フォーカスアウト時のバリデーション
      if (!this.union_key || this.union_key.trim() === '') {
        this.errorMessage = 'ゆにおんキーを入力してください'
      } else {
        this.errorMessage = ''
      }
    },

    submit: function () {
      // バリデーションチェック
      this.validateUnionKey()
      
      // エラーがある場合は処理を中断
      if (this.errorMessage) {
        return
      }
      
      // クエリパラメータに入力されたunion_keyをセットして、/open/login/sso/idpに遷移
      const url = '/open/login/sso/idp'
      this.$router.push(`${url}?union_key=${this.union_key}`)
    }
  }
}
</script>
<style lang='scss' module>
.login {
  display: flex;
  flex-direction: column;
  width: 375px;
  margin: 0 auto;
  padding: 68px 25px 47px 25px;
  box-sizing: border-box;
  text-align: left;

  @include mobile() {
    width: 375px;
    padding: 42px 32px 26px 32px;
  }
}

.title {
  margin-top: 0;
  font-size: 36px;
  font-weight: bold;
  line-height: 44px;
  margin-bottom: 70px;

  @include mobile() {
    font-size: 24px;
    margin-bottom: 60px;
  }
}

.note {
  font-size: 13px;
  color: $fontBlack;
  margin-top: 0;
  margin-bottom: 60px;
}

.next_button_wrap {
  margin-top: 50px;
}

.input_prepend_contact {
  color: $fontBlack !important;
}
</style>
